var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"phoneNumber",staticClass:"form-control",attrs:{"id":"phone_number","autocomplete":"tel","name":"phone_number","placeholder":"Phone Number","type":"tel"},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }